export default __webpack_public_path__ + "static/media/13.b65e3bbe.png";